// import { DetailSupportFormEntrepreneurContainer } from "../../../containers/SupportSystem/SupportForm/DetailSupportFormEntrepreneurContainer";
import { DetailInnovationPersonTrainContainer } from "../../../containers/SupportSystem/SupportForm/DetailInnovationPersonTrainContainer";
export function DetailInnovationPersonTrainPage() {
    return (
        <DetailInnovationPersonTrainContainer/>
    );

}